import e, { forwardRef as h } from "react";
import { Checkbox as o } from "@ark-ui/react";
import { Check as C, Minus as E } from "lucide-react";
import { cx as b, css as k } from "@huspy/styled-system/css";
import { splitCssProps as u } from "@huspy/styled-system/jsx";
import { checkboxRecipe as t } from "@huspy/styled-system/recipes";
import { Text as N } from "../typography/text.mjs";
import "../typography/title.mjs";
const P = h((c, a) => {
  const [s, l] = t.splitVariantProps(c), [m, n] = u(l), { children: i, className: p, textSize: d = "sm", hideIndicator: f = !1, ...x } = n, r = t(s);
  return /* @__PURE__ */ e.createElement(
    o.Root,
    {
      ref: a,
      className: b(r.root, k(m), p),
      ...x
    },
    !f && /* @__PURE__ */ e.createElement(o.Control, { className: r.control }, /* @__PURE__ */ e.createElement(o.Indicator, { className: r.indicator }, /* @__PURE__ */ e.createElement(C, { color: "currentColor" })), /* @__PURE__ */ e.createElement(o.Indicator, { indeterminate: !0, className: r.indicator }, /* @__PURE__ */ e.createElement(E, { color: "currentColor" }))),
    /* @__PURE__ */ e.createElement(o.Label, { className: r.label }, /* @__PURE__ */ e.createElement(N, { size: d }, i)),
    /* @__PURE__ */ e.createElement(o.HiddenInput, null)
  );
});
P.displayName = "Checkbox";
export {
  P as Checkbox
};
